<template>
  <section
    class="schedule bg-color-black text-on-dark py-400 px-300 large:py-600 x-large:d-flex x-large:align-items-center x-large:justify-content-center"
    id="schedule"
    aria-labelledby="h2_schedule"
  >
    <h2
      class="schedule__title section-heading mb-150 large:mb-300 large:text-align-center x-large:text-align-left x-large:mb-0 xx-large:mr-800"
      id="h2_schedule"
    >
      <span>Game</span><br />
      <span class="text-default">Schedule</span>
    </h2>
    <div class="schedule__details">
      <div
        class="schedule__weeks mb-150 large:d-flex large:flex-wrap-wrap large:mb-300 xx-large:mb-400"
      >
        <div
          class="schedule__weeks-item d-flex align-items-center py-150 large:d-block large:py-300 large:text-align-center xx-large:py-0"
          v-for="(item, index) in schedule"
          :key="index"
        >
          <div
            class="schedule__weeks-title text-secondary font-weight-700 text-transform-uppercase mr-600 large:mr-0 large:mb-300"
          >
            {{ item.title }}
          </div>
          <div class="schedule__weeks-days">
            <div
              class="schedule__weeks-days-item font-style-italic"
              v-for="(day, index) in item.days"
              :key="index"
            >
              {{ day }}
            </div>
          </div>
        </div>
      </div>
      <div class="schedule__time text-align-center">
        <span
          class="font-weight-700 text-transform-uppercase d-inline-block mr-75"
          >Start Time:</span
        >
        <span class="font-style-italic">8pm EST</span>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "Schedule",
  props: ["schedule"],
};
</script>

<style lang="scss">
.schedule {
  &__weeks {
    &-title {
      font-size: 1.125rem;
    }
    &-days {
      font-size: 1.3125rem;
      line-height: 1.75;
      white-space: nowrap;
    }
  }

  &__time {
    font-size: 21px;
  }

  @media screen and (min-width: 768px) {
    &__weeks {
      &-item {
        flex: 1 0 33.33%;
      }
    }
  }

  @media screen and (min-width: 1440px) {
    &__details {
      flex: 0 1 auto;
    }

    &__weeks {
      &-item {
        flex: 1 0 0px;

        + .schedule__weeks-item {
          margin-left: 24px;
        }
      }
    }
  }

  @media screen and (min-width: 1800px) {
    &__weeks {
      &-item {
        + .schedule__weeks-item {
        }
      }
    }
  }
}
</style>
